/**
 * Sort fees by order in ascending order
 * @param fees Array of fees with order property (can be null/undefined)
 * @returns Sorted array of fees
 */
export const sortFeesByAscendingOrder = <T extends { order: number }>(fees: T[] | null | undefined): T[] => {
  // Handle case where fees might be null, undefined, or not an array
  if (!fees || !Array.isArray(fees)) {
    return [];
  }

  return [...fees].sort((a, b) => a.order - b.order);
};
